import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import EmptyState from '../EmptyState';
import { getNumberWithCommas } from '../../utilities/money';

const AreaChartComponent = ({ data, performance_summary }) => {
  const CustomizedTooltip = (value, name, props) => {
    return `$ ${getNumberWithCommas(value)}`;
  };

  const tickFormatter = (value) => {
    const limit = 7; // put your maximum character
    let finalValue = value.toString();
    if (finalValue.length < limit) return value;
    return `${finalValue.substr(0, finalValue.length - 3)}K`;
  };

  return (
    <ResponsiveContainer width="98%" height={performance_summary ? 318 : 355}>
      {data && data.length > 0 ? (
        <AreaChart
          data={data}
          margin={{
            top: 50,
            right: 0,
            left: 0,
            bottom: 20,
          }}
        >
          <CartesianGrid vertical={false} strokeDasharray="1 5" />
          <XAxis dataKey="name" />
          <YAxis tickFormatter={tickFormatter} domain={["auto","auto"]} />
          <Tooltip isAnimationActive={false} formatter={CustomizedTooltip} wrapperStyle={{color: "#000000"}} />
          <Legend
            iconType={'circle'}
            layout="horizontal"
            wrapperStyle={{ position: 'absolute', left: '35%' }}
          />
          <Area type="monotone" dataKey="USD" stroke="#3290ED" fill="#3290ED" />
        </AreaChart>
      ) : (
        <EmptyState />
      )}
    </ResponsiveContainer>
  );
};

export default AreaChartComponent;
